import {
  AveniaAccountType,
  AveniaDocumentType,
  AveniaIdentityStatus,
  KycAttemptResult,
  KycAttemptStatus
} from "../../src/services";
import { RampDirection } from "../types/rampDirection";

export enum KycFailureReason {
  FACE = "face",
  NAME = "name",
  BIRTHDATE = "birthdate",
  UNKNOWN = "unknown",
  TAX_ID = "tax_id"
}

// GET /brla/getUser?taxId=:taxId
export interface BrlaGetUserRequest {
  taxId: string;
}

export interface BrlaPostRecordInitialKycAttemptRequest extends BrlaGetUserRequest {
  quoteId: string;
  sessionId?: string;
}
export interface BrlaGetUserResponse {
  evmAddress: string;
  kycLevel: number;
  identityStatus: AveniaIdentityStatus;
  subAccountId: string;
}

// GET /brla/getRampStatus?taxId=:taxId
export interface BrlaGetRampStatusRequest {
  taxId: string;
}

export interface BrlaGetRampStatusResponse {
  type: string;
  status: string;
}

// GET /brla/getKycStatus?taxId=:taxId&quoteId=:quoteId
export interface BrlaGetKycStatusRequest {
  taxId: string;
  quoteId: string;
  sessionId?: string;
}

export interface BrlaGetSelfieLivenessUrlRequest {
  taxId: string;
}

export interface BrlaGetKycStatusResponse {
  type: "KYC";
  level: string;
  status: KycAttemptStatus;
  result: KycAttemptResult;
  failureReason?: KycFailureReason;
}

export interface BrlaGetSelfieLivenessUrlResponse {
  id: string;
  livenessUrl: string;
  uploadURLFront: string;
  validateLivenessToken: string;
}

// GET /brla/validatePixKey?pixKey=:pixKey
export interface BrlaValidatePixKeyRequest {
  pixKey: string;
}

export interface BrlaValidatePixKeyResponse {
  valid: boolean;
}

export interface BrlaGetUserRemainingLimitRequest {
  taxId: string;
  direction: RampDirection;
}

export interface BrlaGetUserRemainingLimitResponse {
  remainingLimit: number;
}

// POST /brla/createSubaccount
export interface BrlaAddress {
  cep: string;
  city: string;
  state: string;
  street: string;
  number: string;
  district: string;
  complement?: string;
}

export type TaxIdType = "CPF" | "CNPJ";

export interface BrlaCreateSubaccountRequest {
  accountType: AveniaAccountType;
  name: string;
  taxId: string;
  quoteId: string;
  sessionId?: string;
}

export interface BrlaCreateSubaccountResponse {
  subAccountId: string;
}

export interface BrlaErrorResponse {
  error: string;
  details?: string;
}

export enum BrlaKYCDocType {
  RG = "RG",
  CNH = "CNH"
}

// POST /brla/startKYC2
export interface AveniaKYCDataUploadRequest {
  documentType: AveniaDocumentType;
  isDoubleSided?: boolean;
  taxId: string;
}

export interface AveniaKYCDataUpload {
  selfieUpload: {
    id: string;
    uploadURLFront: string;
    livenessUrl?: string;
    validateLivenessToken?: string;
  };
  idUpload: {
    id: string;
    uploadURLFront: string;
    uploadURLBack?: string;
  };
}
